import { render } from "./CaroselFiles.vue?vue&type=template&id=88e1b0ec&scoped=true"
import script from "./CaroselFiles.vue?vue&type=script&lang=js"
export * from "./CaroselFiles.vue?vue&type=script&lang=js"

import "./CaroselFiles.vue?vue&type=style&index=0&id=88e1b0ec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e1b0ec"]])

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QIcon,QImg,QBtn});
